import React from "react";
import {
    View,
    Text,
    StyleSheet,
    TouchableOpacity,
    ActivityIndicator,
    Linking
} from "react-native";

import { RFValue } from "react-native-responsive-fontsize";
import {
    Entypo,
    MaterialCommunityIcons,
    Ionicons
} from "@expo/vector-icons";

import Config from "../../Config";
import { Video } from "expo-av";
import WordSplitter from "../Components/WordSplitter";
import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Toast from "../Components/Toast";

const Word = ({ navigation, route }) => {

    const [data, setData] = React.useState(false);
    const [total, setTotal] = React.useState(0);
    const [index, setNumber] = React.useState(0);

    // وضعیت ویدیو
    const [playbackStatus, setPlaybackStatus] = React.useState({});
    const [hasStarted, setHasStarted] = React.useState(false);

    const videoRef = React.useRef(null);

    const word = route.params.word;

    /*
     * با تغییر شماره ویدیو، وضعیت Auto Play ریست می‌شود
     */
    React.useEffect(() => {
        setHasStarted(false);
        setPlaybackStatus({});
    }, [index]);

    /*
     * دریافت اطلاعات کلمه
     */
    React.useEffect(() => {
        getData();
    }, [route.params.word]);

    /*
     * دریافت داده‌ها
     */
    const getData = async () => {
        try {

            let token = await AsyncStorage.getItem("token");

            let res = await axios.get(
                `${Config.api}/user/wordsearch/?word=${word}`,
                {
                    headers: {
                        Authorization: "Bearer " + token
                    }
                }
            );




            if (res.data.code != 1) {
                Toast(res.data.error);
            }

            if (res.data.words.length > 0) {
                setData(res.data.words);
                setNumber(0);
                setTotal(res.data.words.length);

            } else {



                setData(false);
                setNumber(0);
                setTotal(0);

            }

        } catch (err) {

            console.log(err);
            alert("خطا");

        }
    };

    /*
     * رفتن به ویدیوی بعدی
     */
    const next = () => {

        if (index + 1 != total) {
            setNumber(index + 1);
        }

    };

    /*
     * رفتن به ویدیوی قبلی
     */
    const prev = () => {

        if (index > 0) {
            setNumber(index - 1);
        }

    };

    /*
     * مدیریت وضعیت پخش ویدیو
     *
     * وقتی ویدیو از سرور با تأخیر Load شد،
     * به محض اینکه isLoaded=true شود،
     * پخش به صورت خودکار شروع می‌شود.
     */
    const handlePlaybackStatus = async (status) => {

        setPlaybackStatus(status);

        if (status.isLoaded && !hasStarted) {

            setHasStarted(true);

            try {

                await videoRef.current?.playAsync();

            } catch (error) {

                console.log("Auto play error:", error);

            }
        }
    };

    /*
     * URL ویدیو
     */
    const videoUrl = data
        ? `${Config.meet}/stream.php?video=${data[index].url}&start=${data[index].start}&end=${data[index].end}`
        : "";

    return (
        <View style={styles.container}>

            {/* Header */}
            <View style={styles.header}>

                <TouchableOpacity style={{ flex: 1 }}>
                    <Text style={styles.title}>
                        {word}
                    </Text>
                </TouchableOpacity>

                <TouchableOpacity
                    onPress={() => {
                        navigation.goBack();
                    }}
                >
                    <Ionicons
                        style={styles.selficon}
                        name="arrow-back"
                        size={24}
                        color="white"
                    />
                </TouchableOpacity>

            </View>

            {/* اگر ویدیویی وجود نداشت */}
            {total === 0 ? (

                <View
                    style={{
                        flex: 1,
                        backgroundColor: Config.maincolor,
                        alignItems: "center"
                    }}
                >

                    <Text style={styles.headertxt}>
                        {word}
                    </Text>

                    <Text style={styles.subheadertxt}>
                        متاسفانه برای کلمه فوق ویدیو پیدا نشد !
                    </Text>

                    <TouchableOpacity
                        style={styles.button}
                        onPress={() => {
                            navigation.goBack();
                        }}
                    >
                        <Text style={styles.buttonText}>
                            بازگشت
                        </Text>
                    </TouchableOpacity>

                </View>

            ) : (

                <View
                    style={{
                        flex: 1,
                        backgroundColor: Config.maincolor,
                        alignItems: "center"
                    }}
                >

                    {/* Video */}
                    <View style={styles.videoContainer}>

                        <Video
                            ref={videoRef}

                            /*
                             * باعث می‌شود با تغییر index،
                             * ویدیوی قبلی کاملاً Unmount شود.
                             */
                            key={index}

                            style={styles.video}

                            /*
                             * ویدیو به صورت Loop پخش می‌شود.
                             */
                            isLooping={true}

                            /*
                             * خودمان بعد از Load شدن
                             * playAsync() را اجرا می‌کنیم.
                             */
                            shouldPlay={false}

                            source={{
                                uri: videoUrl
                            }}

                            useNativeControls

                            resizeMode="contain"

                            onPlaybackStatusUpdate={
                                handlePlaybackStatus
                            }
                        />

                        {/* Loading */}
                        {!playbackStatus.isLoaded && (
                            <ActivityIndicator
                                size="large"
                                color={Config.secondcolor}
                                style={styles.loading}
                            />
                        )}

                    </View>

                    {/* متن */}
                    <TwoLineText
                        showfarsi={true}
                        showenglish={true}
                        text={data[index].text}
                    />

                    {/* کنترل قبلی / بعدی */}
                    <View
                        style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            paddingVertical: RFValue(10),
                            width: "85%"
                        }}
                    >

                        {/* Next */}
                        <TouchableOpacity
                            onPress={next}
                            style={styles.icon}
                        >
                            <Entypo
                                name="controller-next"
                                size={24}
                                color={Config.maincolor}
                            />
                        </TouchableOpacity>

                        {/* Number */}
                        <Text style={styles.number}>
                            {index + 1}/{total}
                        </Text>

                        {/* Previous */}
                        <TouchableOpacity
                            onPress={prev}
                            style={styles.icon}
                        >
                            <MaterialCommunityIcons
                                name="skip-previous"
                                size={24}
                                color={Config.maincolor}
                            />
                        </TouchableOpacity>

                    </View>

                    {/* Back */}
                    <TouchableOpacity
                        style={styles.button}
                        onPress={() => {
                            navigation.goBack();
                        }}
                    >
                        <Text style={styles.buttonText}>
                            بازگشت
                        </Text>
                    </TouchableOpacity>

                    {/* Open Stream */}
                    {/*<TouchableOpacity*/}
                    {/*    style={styles.button}*/}
                    {/*    onPress={() => {*/}
                    {/*        Linking.openURL(videoUrl);*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <Text style={styles.buttonText}>*/}
                    {/*        باز کردن ویدیو*/}
                    {/*    </Text>*/}
                    {/*</TouchableOpacity>*/}

                </View>

            )}

        </View>
    );
};


/*
 * نمایش متن انگلیسی و فارسی
 */
function TwoLineText({
                         text,
                         showfarsi = true,
                         showenglish = true
                     }) {

    let firstLine = "";
    let secondLine = "";

    if (text.includes("\n")) {

        const lines = text.split("\n");

        firstLine = lines[0];

        secondLine = lines
            .slice(1)
            .join("\n");

    } else {

        firstLine = text;

    }

    return (

        <View
            style={{
                alignItems: "center",
                paddingVertical: RFValue(15),
                paddingHorizontal: 10
            }}
        >

            {showenglish && (
                <WordSplitter
                    text={firstLine}
                />
            )}

            {showfarsi && (

                <Text
                    style={{
                        color: Config.secondcolor,
                        fontSize: 16,
                        fontFamily: "ykb",
                        marginTop: RFValue(2)
                    }}
                >
                    {secondLine}
                </Text>

            )}

        </View>

    );
};


const styles = StyleSheet.create({

    videoContainer: {
        width: "98%",
        height: RFValue(200),
        justifyContent: "center",
        alignItems: "center",
        marginTop: RFValue(10),
        position: "relative"
    },

    loading: {
        position: "absolute"
    },

    button: {
        backgroundColor: Config.secondcolor,
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        width: RFValue(130),
        height: RFValue(35),
        marginTop: RFValue(30),
        borderRadius: RFValue(10)
    },

    buttonText: {
        fontFamily: "yk",
        fontSize: RFValue(16),
        color: Config.maincolor
    },

    icon: {
        width: RFValue(40),
        height: RFValue(40),
        backgroundColor: "whitesmoke",
        borderRadius: RFValue(40),
        justifyContent: "center",
        alignItems: "center"
    },

    video: {
        width: "100%",
        height: "100%",
        borderRadius: RFValue(5)
    },

    subheadertxt: {
        fontFamily: "yk",
        fontSize: RFValue(11),
        marginVertical: RFValue(8),
        color: "#E4E4E4",
        textAlign: "justify"
    },

    headertxt: {
        fontFamily: "ykb",
        fontSize: RFValue(18),
        marginVertical: RFValue(8),
        color: "#FFF"
    },

    number: {
        fontFamily: "yk",
        fontSize: RFValue(14),
        marginVertical: RFValue(8),
        color: "#E4E4E4",
        textAlign: "justify"
    },

    container: {
        flex: 1,
        backgroundColor: Config.maincolor
    },

    header: {
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        backgroundColor: "#000422",
        paddingHorizontal: RFValue(20),
        shadowColor: "#000000",
        shadowOffset: {
            width: 0,
            height: 50
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },

    title: {
        fontSize: RFValue(17),
        fontFamily: "ykb",
        color: "#FFF",
        paddingVertical: RFValue(14)
    }

});

export default Word;